import React from "react";

import { faPlus } from "@fortawesome/pro-regular-svg-icons";

import { SubHeader } from "src/flow/SubHeader";
import { SubHeaderSearchBox } from "src/layout/SubHeader";

type SdkBundlesToolbarProps = {
  searchQuery: string;
  onSearchChange: (query: string) => void;
  onAddClick: () => void;
  searchDataLoc?: string;
  addDataLoc?: string;
  addTooltip?: string;
};

export const SdkBundlesToolbar: React.FC<SdkBundlesToolbarProps> = ({
  searchQuery,
  onSearchChange,
  onAddClick,
  searchDataLoc = "sdk-bundles-search",
  addDataLoc = "sdk-bundles-add-button",
  addTooltip = "Add SDK bundle",
}) => {
  return (
    <>
      <SubHeaderSearchBox
        dataLoc={searchDataLoc}
        defaultValue={searchQuery}
        placeholder="Search SDK bundles..."
        onChange={onSearchChange}
      />
      <SubHeader.Button
        dataLoc={addDataLoc}
        icon={faPlus}
        tooltip={addTooltip}
        onClick={onAddClick}
      />
    </>
  );
};
